import { render, staticRenderFns } from "./AngleWidgetComponent.vue?vue&type=template&id=0aeff7ea&scoped=true&"
import script from "./AngleWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./AngleWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AngleWidgetComponent.vue?vue&type=style&index=0&id=0aeff7ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeff7ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
